/*
 * View for selecting a content mapping, including a nav tree
 * and a selectable list for showing the contents of a folder
 */

define([
  "marionette",
  "messaging/messenger",
  "modules/shared/contentMapping/template/contentMappingTemplate.html",
  "modules/typeahead/typeaheadModel",
], function (Marionette, Messenger, ContentMappingTemplate, TypeaheadModel) {
  var ContentMappingView = {};

  ContentMappingView.contentMappingLayout = Marionette.Layout.extend({
    template: ContentMappingTemplate,
    regions: {
      contentTree: "#navTree",
      contentList: "#navList",
    },
    onRender: function () {
      this.$el.i18n();
      //set up source function to get the typeahead data
      var _this = this;
      var sourceFunction = function (query, process) {
        var results = Messenger.reqres.request("contents:typeahead", query);
        results.once(
          "sync",
          function () {
            process(results.getResultsArray());
          },
          this,
        );
      };

      this.$el.find("input").typeahead({
        source: sourceFunction,
        updater: function (item) {
          //set the value of the textbox
          _this.$el.find("input").val(item);
          _this.trigger("search", item); //trigger event on view, passing the search query
          return item;
        },
      });
    },
  });

  return ContentMappingView;
});
